<template>
  <p class='name' >
    <span class='circle' ></span>
    {{name}}
  </p>
</template>

<script>
export default {
  props:['name'],
  name: "CicrleName",

}
</script>

<style scoped lang="less">
  .name {
    font-size: 16px;
    display: flex;
    align-items: center;
    line-height: 24px;
    .circle {
      width: 12px;
      height: 12px;
      background: #00A2FF;
      border: 2px solid #D4F0FF;
      border-radius: 50%;
      margin-right: 5px;
    }
  }
</style>